export const WEBAPP_GRATIFICATIONS_CLICKED = 'WEBAPP_GRATIFICATIONS_CLICKED';
export const WEBAPP_GRATIFICATIONS_VIEWED = 'WEBAPP_GRATIFICATIONS_VIEWED';
export const WEBAPP_GRATIFICATIONS_USEFUL = 'WEBAPP_GRATIFICATIONS_USEFUL';
export const WEBAPP_GRATIFICATIONS_NOTUSEFUL =
  'WEBAPP_GRATIFICATIONS_NOTUSEFUL';
